<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
    	
	     <el-form :inline="true" class="demo-form-inline backborder1" size="small">
	         <el-form-item>
	             <el-input placeholder="商品名称 / 条形码 / 编号 / 拼音码" v-model="productquery.codekey" @keyup.enter.native="addDialogsingle" id="searchInput"></el-input>
	         </el-form-item>
	         <el-form-item>
	             <el-button size="small" type="warning" @click="addmoregoods">新增商品</el-button>
	         </el-form-item>
			 <el-form-item>
	             <el-button size="small" type="warning" @click="addmore">导入商品</el-button>
	         </el-form-item>
			 <el-form-item>
	             <el-button size="small" type="" @click="delcart">清空商品</el-button>
	         </el-form-item>
			 <el-form-item>
				 <div style="font-size:12px;color:red">注：盘点时请先停止其它跟出入库相关的操作</div>       		
	         </el-form-item>
	     </el-form>


		<!-- 基础数据信息 -->
		<div class="backborder1" style="margin-top:10px;padding-bottom:10px;position:relative;overflow:hidden;">
			<div class="cz-sell-base-lists-infos-out">
				<!-- 盘点日期 -->
				<div class="cz-sell-base-lists-infos">
					<span class="cz-sell-base-lists-infos-title">盘点日期</span>
					<div class="cz-sell-base-lists-infos-content">
						<el-date-picker type="date" placeholder="请选择盘点日期" v-model="create.makeday" value-format="yyyy-MM-dd"></el-date-picker>
					</div>
				</div>
				<!-- 盘点仓库 -->
				<div class="cz-sell-base-lists-infos">
					<span class="cz-sell-base-lists-infos-title">盘点仓库</span>
					<div class="cz-sell-base-lists-infos-content">
						<el-select v-model="productquery.warehouse" placeholder="请选择盘点仓库">
							<el-option v-for="(item,index) in wareHouseLists" :label="item.name" :value="item.id" :key="index" v-if="defaultwarehous==''"></el-option>
							<el-option v-for="(item,index) in wareHouseLists" :label="item.name" :value="item.id" :key="index" v-if="defaultwarehous!='' && item.id!=defaultwarehous" disabled></el-option>
							<el-option v-for="(item,index) in wareHouseLists" :key="index" :label="item.name" :value="item.id" v-if="defaultwarehous==item.id"></el-option>
						</el-select>
					</div>
				</div>
				<!-- 盘点人员 -->
				<div class="cz-sell-base-lists-infos">
					<span class="cz-sell-base-lists-infos-title">盘点人员</span>
					<div class="cz-sell-base-lists-infos-content">
						<el-select v-model="create.sysmanager" filterable placeholder="请选择经手人">
							<el-option v-for="(item,index) in sysmanagers" :key="index" :label="item.truename" :value="item.id"></el-option>
						</el-select>
					</div>
				</div>
			</div>

			<div class="cz-sell-base-lists-infos-goods">
				<el-table :data="lists" border="1" v-loading="listsLoading" show-summary :summary-method="totalRule">
					<el-table-column prop="name" label="商品信息" min-width="300">
						<template slot-scope="scope">
							<span style="float:left;width:100%;font-size:13px;line-height:23px;">{{scope.row.name}}</span>
							<span style="float:left;width:100%;font-size:12px;line-height:23px;color:#999999" v-if="scope.row.number!=''">编号：{{scope.row.number}}</span>
						</template>
					</el-table-column>
					<el-table-column label="商品条码" align="center" min-width="120">
						<template slot-scope="scope">
							<div style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.unitcode}}</div>
						</template>
					</el-table-column>
					<el-table-column label="单位" align="center" min-width="120">
						<template slot-scope="scope">
							<div style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.unit}}</div>
						</template>
					</el-table-column>
					<el-table-column label="批发价" align="center" min-width="120">
						<template slot-scope="scope">
							<div style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.sell}}</div>
						</template>
					</el-table-column>
					<el-table-column label="系统库存" align="center" min-width="120">
						<template slot-scope="scope">
							<div style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.inventory}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="reainventory" label="实际库存" align="center" min-width="120">
						<template slot-scope="scope">
							<el-input size="small" v-model="scope.row.reainventory" :id="scope.$index==0 ?  'realfirst' : ''" @blur="blurinventory(scope.row)"  @keyup.enter.native="listeninventory(scope.row)"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="profit" label="盘盈" align="center" min-width="120">
						<template slot-scope="scope">
							<div style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.profit}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="lose" label="盘亏" align="center" min-width="120">
						<template slot-scope="scope">
							<div style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.lose}}</div>
						</template>
					</el-table-column>
					<el-table-column label="成本价" align="center" min-width="120">
						<template slot-scope="scope">
							<el-input size="small" v-model="scope.row.cost" @blur="changeCost(scope.row)" />
						</template>
					</el-table-column>
					<el-table-column prop="allcost" label="成本小计" align="center" min-width="120">
						<template slot-scope="scope">{{scope.row.allcost|CFMprice}}</template>
					</el-table-column>
					<el-table-column label="操作" align="center" min-width="120" fixed="right">
						<template slot-scope="scope">
							<el-button round size="small" type="" @click="delCurrent(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<div class="cz-sell-order-stat">
            <div class="cz-sell-order-stat-totals"></div>
            <div class="cz-sell-order-stat-handles">
                <el-button size="small" type="warning" round :loading="suresaveLoading" @click="createSave">确认盘点</el-button>
            </div>
			</div>

		</div>


	      
	    <!---------------------- 新增商品信息列表 ------------------------>
        <el-dialog title="添加产品" :visible.sync="addDialog" width="55%" top="1vh">
        	<el-tag type="danger">温馨提示：添加盘点商品时，购物车里每个商品只能添加一次，不区分管理员</el-tag>
            <el-form :inline="true" class="demo-form-inline" style="margin-top:15px" size="small">
	            <el-form-item>
		            <el-select v-model="productquery.brandid" clearable filterable placeholder="按品牌"  @change="selectbrand">
		                <el-option label="不分品牌" value="0"></el-option>
		                <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
		                	<span style="float: left">{{item.name}}</span>
      				        <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
		                </el-option>
		            </el-select>
	            </el-form-item>
				<!--
	            <el-form-item>
	                <el-cascader :options="categorylist" v-model="productquery.catid" clearable placeholder="请选择分类" @change="selectcate"></el-cascader>
	            </el-form-item>
				-->
	            <el-form-item>
	            	<el-input placeholder="商品名称 / 条形码 / 编号 / 拼音码" v-model="productquery.key" clearable @keyup.enter.native="getProductList" @change="isnewselect=true"></el-input>
	            </el-form-item>
	            <el-form-item>
	            	<el-button type="warning" icon="el-icon-search" @click="getProductList">查询</el-button>
	            </el-form-item>
          	</el-form>
	        <el-table ref="multipleTable" :data="productlists" style="width: 100%" v-loading="addListLoading" tooltip-effect="dark" @row-click="handleSelectRow" @select="handleSelectsingle"  @select-all="handleSelectall">
	            <el-table-column type="selection" min-width="90" />
				<el-table-column label="名称" min-width="300">
					<template slot-scope="scope">
						<div style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.name}}</div>
						<div style="float:left;width:100%;font-size:12px;line-height:23px;color:#999999">编码：{{scope.row.number}}</div>
					</template>
				</el-table-column>
	            <el-table-column label="售价" min-width="150" align="center">
					<template slot-scope="scope">
						<div style="float:left;width:100%;font-size:13px;line-height:23px">{{scope.row.showsell}}</div>
					</template>
				</el-table-column>
	        </el-table>
	        <div class="block">
	            <!--分页begin-->
	            <el-pagination
	            	@size-change="productPageSizeChange"
	            	@current-change="productPageCurrentChange"
	            	:current-page="productquery.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="productquery.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="total_product_rows">
	            </el-pagination>
	            <!--分页end-->
	        </div>
	        <div slot="footer" class="dialog-footer">
	            <el-button size="small" @click="addDialog = false">取 消</el-button>
	            <el-button size="small" type="warning" :loading="addProductLoading" @click="addCart">确认添加</el-button>
	        </div>
        </el-dialog>        		
  		
  		<!---------------------- 批量新增盘点商品信息列表 ------------------------>
        <el-dialog title="批量添加盘点产品" :visible.sync="addmoreDialog" width="75%" top="5vh">
		    <el-tag type="danger">温馨提示：请下载对应的模板文件，如模板中示例一样添加完整的商品信息，谢绝自定义模板</el-tag>
		    <div style="width:100%;margin-top:20px">
			    <input id="fileupload" type="file" @change="importfile(this)"  accept="" style="display:none" title="1"/>
			    <el-button type="primary" size="small" icon="el-icon-download" @click="exportgoods">下载excel模板文件</el-button>
			    <el-button type="success" size="small" icon="el-icon-upload2" @click="uploadinfos">上传文件</el-button> 
      	    </div>
      	    <el-table :data="productsmore" tooltip-effect="dark" style="margin-top:20px" v-loading="uploadgoodsLoading">
	            <el-table-column prop="code" label="条形码"></el-table-column>
	            <el-table-column prop="name" label="商品名称"></el-table-column>
	            <el-table-column prop="spec" label="规格"></el-table-column>
	            <el-table-column prop="inventory" label="实际库存数量" align="center" style="width:15%">
	            	<template slot-scope="scope">
	            	<el-input v-model="scope.row.inventory" style="width:50%" size="small"></el-input>
	            	</template>
	            </el-table-column>
	            <el-table-column label="操作" align="center">
	                <template slot-scope="scope">
	            		<el-button type="danger" size="mini" icon="el-icon-delete" @click="productsmore.splice(scope.$index,1)"></el-button>
	                </template>
	            </el-table-column>
	        </el-table>
			
	        <div slot="footer" class="dialog-footer">
	            <el-button size="small" type="primary" :loading="addmoreloading" @click="addmoreSave">确认</el-button>
	        </div>
        </el-dialog>
        
        <el-dialog title="获取未盘点商品信息" :visible.sync="exportDialog" width="82%" top="5vh">
  			<el-form :inline="true" class="demo-form-inline" style="margin-top:15px" size="small">
	  			<el-form-item style="width:22%">
		    		<el-date-picker v-model="exportquery.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :unlink-panels="false" style="width:100%"></el-date-picker>
		    	</el-form-item>
		    	<el-form-item style="width:13%">
			    	<el-select v-model="exportquery.warehouseid" clearable placeholder="请选择发货仓库">
					    <el-option v-for="(item,index) in wareHouseLists" :label="item.name" :value="item.id" :key="index"></el-option>
					</el-select>
		    	</el-form-item>
		    	<el-form-item style="width:13%">
			    	<el-select v-model="exportquery.managerid" clearable placeholder="请选择盘点人">
					    <el-option v-for="(item,index) in sysmanagers" :label="item.truename" :value="item.id" :key="index"></el-option>
					</el-select>
		    	</el-form-item>
		    	<el-form-item style="width:13%">
			    	<el-select v-model="exportquery.brandid" clearable filterable placeholder="请选择品牌">
					    <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
					    	<span style="float: left">{{item.name}}</span>
      				        <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
					    </el-option>
					</el-select>
		    	</el-form-item>
		    	<el-form-item style="width:13%">
		            <el-cascader :options="categorylist" v-model="exportquery.catid" clearable placeholder="请选择分类"></el-cascader>
		        </el-form-item>
		        <el-form-item>
		            <el-button type="primary" icon="el-icon-search" @click="getUncounted">查询</el-button>
		            <el-button type="primary" icon="el-icon-search" @click="exportdata">导出</el-button>
		        </el-form-item>
	        </el-form>
	        <el-table :data="exportlists" border style="width: 100%" v-loading="exportLoading">
				<el-table-column label="商品名称" prop="name"></el-table-column>
				<el-table-column label="品牌" prop="brandname" width="110"></el-table-column>
			    <el-table-column label="编号" prop="number" width="95" align="center"></el-table-column>
			    <el-table-column label="规格" prop="spec" align="center" width="80"></el-table-column>
			    <el-table-column label="条形码" prop="basebarcode" align="center" width="140"></el-table-column>
				<el-table-column label="系统库存（基本单位）" prop="basenum" align="center" width="180"></el-table-column>
    		</el-table>
  		</el-dialog>

		<el-dialog title="最近商品盘点记录" :visible.sync="checkmakeDialog" width="90%" top="5vh">
			<div class="stockallcover">
				<el-radio size="mini" v-model="covergoods" label="1" border @change="changecover">全选叠加</el-radio>
				<el-radio size="mini" v-model="covergoods" label="2" border @change="changecover">全选覆盖</el-radio>
				<el-radio size="mini" v-model="covergoods" label="3" border @change="changecover">全选忽略</el-radio>
			</div>

	    	<el-table :data="create.productlog" tooltip-effect="dark" style="margin-top:5%">
	            <el-table-column prop="number" label="编号" width="100"></el-table-column>
	            <el-table-column prop="name" label="商品名称" width="200"></el-table-column>
	            <el-table-column prop="spec" label="规格" width="85"></el-table-column>
	            <el-table-column prop="inventory" label="系统库存" width="85" align="center"></el-table-column>
	            <el-table-column prop="reainventory" label="实际库存" width="85" align="center"></el-table-column>
	            <el-table-column prop="profit" label="盈" width="85" align="center"></el-table-column>
	            <el-table-column prop="lose" label="亏" width="85" align="center"></el-table-column>
	            <el-table-column prop="inputtime" label="时间" width="160" align="center"></el-table-column>
	            <el-table-column label="操作" align="center">
	                <template slot-scope="scope">
						<div class="singlecover">
					    <el-radio-group v-model="scope.row.type" size="mini">
						    <el-radio label="1" border>叠加</el-radio>
						    <el-radio label="2" border>覆盖</el-radio>
						    <el-radio label="3" border>忽略</el-radio>
						</el-radio-group>
						</div>
	                </template>
	            </el-table-column>
	        </el-table>
	        
	        <div slot="footer" class="dialog-footer">
	            <el-button size="medium" @click="checkmakeDialog = false">取 消</el-button>
	            <el-button size="medium" type="primary" @click="Savemakeinfos">确认</el-button>
	        </div>
  		</el-dialog>  
    	
    </div>    
    </transition>
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"StockInventory/index",
      transitionshow:true,
      actionauth:[],
      productquery:{
        act:'getinventory',
        token:this.$cookies.get('token'),
        brandid:'',
        catid:'',
        warehouse:'',
        key:'',
        codekey:'',
        rollpage: 10, // 页大小
        p: 1
      },
      listsLoading:false,
      lists:[],
      defaultwarehouse:'',
      wareHouseLists:[],
	  brandlists:[],
	  categorylist:[],
	  sysmanagers:[],
	  isnewselect:false,
	  suresaveLoading:false,
	  create:{
      	  act:'savemakeinventory',
          token:this.$cookies.get('token'),
          sysmanager:'',
          makeday:new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),
          productlog:[],
      },
      addDialog:false,
	  listLoading:false,
      addListLoading:false,
      multipleSelection:[],
      addmoreDialog:false,
      productsmore:[],
      productnotice:[],
      isopenselect:false,
      addListLoading:false,
      productlists:[],
      total_product_rows:0,
      checkmakeDialog:false,
      suresaveLoading:false,
      createsaveLoading:false,
      suresaveLoading:false,
      issingleclick:false,
	  nowtime:0,
	  timeoutflag:true,
	  addProductLoading:false,
	  uploadgoodsLoading:false,
	  productsmore:[],
	  addmoreDialog:false,
	  addmoreloading:false,
	  exportDialog:false,
	  exportquery: {
	  	  act:'getUncounted',
	      token:this.$cookies.get('token'),
	      date:'',
	      warehouseid:'',
	      managerid:'',
	      brandid:'',
	      catid:'',
		  isexport:1,
	  },
	  exportlists:[],
	  exportLoading:false,
	  covergoods:'',
    }
  },

  filters: {
    /** 价格信息保留两位小数 **/
    CFMprice(value) {
       var price=parseFloat(value); //修剪去小数点后多余的0
       var numsobj=price.toString().split(".");	//判断小数点后有几位小数
       var result=0.00;

       if(numsobj.length==1) result=price.toFixed(2); //值为0时补充到2位
       if(numsobj.length > 1 && numsobj[1].length <= 2) result=price.toFixed(2); //值为小数点后只有1位小数时补充到2位
       if(numsobj.length > 1 && numsobj[1].length > 2) result=price; //小数点后的值超出2位时直接返回
       return result;		
    }
  },
  
  
  mounted(){
  	  this.getactionauth(); //获取权限设置
      this.getlists(); //获取盘点商品列表
      this.getBrand();
      this.getCategoryList();
      this.getSysmanager();
      this.getWarehouse();
  },
  
  
  methods:{

	  /** 调整数字格式 **/
	  changepriceformat(value) { 
		  var price=parseFloat(value); //修剪去小数点后多余的0
		  var numsobj=price.toString().split(".");	//判断小数点后有几位小数

		  if(numsobj.length==1) return price.toFixed(2); //值为0时补充到2位
		  if(numsobj.length > 1 && numsobj[1].length <= 2) return price.toFixed(2); //值为小数点后只有1位小数时补充到2位
		  if(numsobj.length > 1 && numsobj[1].length > 2) return price; //小数点后的值超出2位时直接返回
	  }, 

      
      /** 获取操作功能权限 **/
  	  getactionauth() {
    	  var data =this.$cookies.get('actionauth');
    	  data=JSON.parse(data);
          this.actionauth=data;
      },
      
      /** 获取盘点信息列表 **/
      getlists() {
      	  this.listsLoading=true;
      	  var resource = this.$resource(this.url);
          resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	              this.listsLoading=false;
	          }else{
	          	  this.lists=JSON.parse(Base64.decode(res.data.Data));
	              this.listsLoading=false;
				  var _this=this;
				  this.lists.forEach(function(e,index) {
					  e.cost=_this.changepriceformat(e.cost);
				  });

	              if(this.lists!='') {
	              	  this.defaultwarehous=this.lists[0]['warehouse'];
	              	  this.productquery.warehouse=this.lists[0]['warehouse'];
	              }else {
	              	  this.defaultwarehous='',
	              	  this.productquery.warehouse='';
	              }
	          }
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
              this.listsLoading=false;
          });
      },


	  totalRule() {
	    var _this=this;
	    var sysnum=0;
		var realnum=0;
		var profitnum=0;
		var losenum=0;
		var costs=0;	   

	    this.lists.forEach(function(e,index) {
			sysnum += parseInt(e.inventory);
			realnum += parseInt(e.reainventory)||0;
			profitnum += parseInt(e.profit);
			losenum += parseInt(e.lose);
			costs += parseFloat(e.allcost);
		});

		costs=costs.toFixed(2);
		return ['合计','','','',sysnum,realnum,profitnum,losenum,'',costs];
	  },

      
      /** 获取仓库 **/
      getWarehouse(){
          var resource = this.$resource(this.GLOBAL.domain+"Ware/index");
          resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	          }else{
	              this.wareHouseLists = JSON.parse(Base64.decode(res.data.Data));
	          }
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
          });
      },
      
      
      /** 获取品牌 **/
      getBrand(){
          var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
          resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	          }else{
	              this.brandlists = JSON.parse(Base64.decode(res.data.Data));
	          }
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
          });
      },
      
      
      /** 获取产品分类 **/
      getCategoryList() {
    	  var resource = this.$resource(this.GLOBAL.domain+"Product/index");
          resource.query({ act:'getcatelist',token:this.$cookies.get('token')}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	          }else{
	              this.categorylist=JSON.parse(Base64.decode(res.data.Data));
	          }
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
          });
      },
      
      
      /** 获取经手人 **/
      getSysmanager() {
          var resource = this.$resource(this.GLOBAL.domain+"Manager/index");
          resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:10000,p:1}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	          }else{
	              this.sysmanagers = JSON.parse(Base64.decode(res.data.Data));
	              this.create.sysmanager=this.$cookies.get('managerid');
	          }
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
          });
      },
      
      
      /** 品牌搜索（品牌发生变化时触发一次搜索） **/
      selectbrand() {
    	  this.isnewselect=true;
    	  this.getProductList();
      },
      
      
      /** 分类搜索（分类发生变化触发一次搜索） **/
      selectcate() {
    	  this.isnewselect=true;
    	  this.getProductList();
      },
      
      /** 点击添加商品列表获取添加商品列表 **/
      addmoregoods() {
      	  if(this.productquery.warehouse=='') {this.$message.error("请选择盘点仓库");return false;}
		  this.addDialog=true,
      	  this.addListLoading=true,
      	  
      	  this.productquery.brandid='';
      	  this.productquery.catid=[];
      	  this.productquery.key='';
      	  this.multipleSelection=[]; 	
    	  this.getProductList();
      },
      
      /** 批量添加商品信息 **/
      addmore() {
      	  if(this.productquery.warehouse=='') {this.$message.error("请选择盘点仓库");return false;}
      	  this.productsmore=[];
		  this.productnotice=[];
      	  this.addmoreDialog=true;
      },
      
      /** 清空购物车里的商品 **/
      delcart() {
      	  this.$confirm('您是否确定要删除所有盘点的商品，继续?', '提示', { type: 'warning' }).then(() => {    	
        	  // 向请求服务端删除
			  var resource = this.$resource(this.url);
	          resource.save({act:'delproductall',token:this.$cookies.get('token')}).then((res) => {
	              if(res.data.Result>0){
		              if(res.data.Result=='70001') this.$router.push('/login')
		              this.$message.error(res.data.Message);
		              //聚焦搜索关键字
	                  this.setkeylisten();
	              }else{
	                  this.$message.success('删除盘点商品成功！');
	                  this.getlists();
	                  //聚焦搜索关键字
	                  this.setkeylisten();
	              }
	          }).catch((res) => {
	              //this.$message.error(this.GLOBAL.errortext);
	          });
          }).catch(() => {
              this.$message.info('已取消操作!');
          });
      },
      
      /** 删除商品 **/
      delCurrent(item) {
      	  this.$confirm('您是否确定要删除盘点的商品：'+item.name+'，继续?', '提示', { type: 'warning' }).then(() => {    	
        	  // 向请求服务端删除
			  var resource = this.$resource(this.url);
	          resource.save({act:'delproduct',id:item.id,token:this.$cookies.get('token')}).then((res) => {
	              if(res.data.Result>0){
		              if(res.data.Result=='70001') this.$router.push('/login')
		              this.$message.error(res.data.Message);
	              }else{
	                  this.$message.success('删除盘点商品成功！');
	                  this.getlists();
	                  //聚焦搜索关键字
	                  this.setkeylisten();
	              }
	          }).catch((res) => {
	              //this.$message.error(this.GLOBAL.errortext);
	          });
          }).catch(() => {
              this.$message.info('已取消操作!');
          });
      },
      
      blurinventory(item) {
      	  this.changeinventory(item);
      },

	  
	  /** 修改成本价 **/
	  changeCost(item) {
		  var resource = this.$resource(this.url);
	      resource.save({act:'changecost',id:item.id,cost:item.cost,token:this.$cookies.get('token')}).then((res) => {
	          if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
	          }else{
	              this.getlists();
	          }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
	  },


      
      listeninventory(item) {
      	  this.changeinventory(item);
      	  //搜索关键字聚焦
      	  this.setkeylisten();
      },
      
      /** 修改实际库存 **/
      changeinventory(item) {
	      var resource = this.$resource(this.url);
	      resource.save({act:'changeinventory',id:item.id,inventory:item.reainventory,token:this.$cookies.get('token')}).then((res) => {
	      	  if(res.data.Result>0){
		          if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
	          }else{
	              this.getlists();
	          }
	      }).catch((res) => {
	          //this.$message.error(this.GLOBAL.errortext);
	      });
      },
      
      /** 确认盘点 **/
      createSave() {
      	  if(this.lists=='') {this.$message.error("请选择需要盘点的商品");return false;}
      	  if(this.create.sysmanager=='') {this.$message.error("请选择盘点人");return false;}
      	  if(this.create.makeday=='') {this.$message.error("请选择盘点日期");return false;}
      	  this.create.productlog=[];
      	  
      	  //检查盘点数据中是否有最近刚盘点的信息
      	  this.checklog();      	   	  
      },


	  /** 扫码添加商品信息 **/
      addDialogsingle() {      
      	  this.productquery.key=this.productquery.codekey;
    	  var resource = this.$resource(this.url);
          resource.query({act:'sweep',warehouseid:this.productquery.warehouse,key:this.productquery.key,token:this.$cookies.get('token')}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	          }else{
	        	  if(Base64.decode(res.data.Data)==1) { //有1个以上则展开列表 
	        	  	  this.addDialog=true;
      	  			  this.addListLoading=true;  
	        		  this.getProductList();
	        		  this.productquery.codekey='';
	        	  }else { //扫码解析同一个产品只有1个则直接添加
	        		  this.multipleSelection=[];
	        		  this.multipleSelection.push(JSON.parse(Base64.decode(res.data.Data)));
	        		  this.addSave();
	        		  this.setkeylisten(); //聚焦关键字光标搜索
	        		  this.productquery.codekey='';
	        	  }
	          }
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
          });
      },
      
      /** 产品信息列表 **/
      getProductList(){      	  
    	  if(this.isnewselect==true) {
			  this.productquery.p=1;
			  this.productquery.rollpage=10;	    	
    	  }
    	
    	  this.isopenselect=false; //关闭点击单行自动添加数据
    	  var _this=this;
          this.addListLoading = true;
          var resource = this.$resource(this.url);
          resource.query(this.productquery).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	              this.addListLoading = false;
	          }else{
	              this.productlists = JSON.parse(Base64.decode(res.data.Data));
	              this.total_product_rows=parseInt(res.data.count);           
	              this.addListLoading = false;

				  this.productlists.forEach(function(item,index) {
					  item.brandname ? item.name='【'+item.brandname+'】'+item.name : '';
					  item.spec ? item.name+=' ['+item.spec+']' : '';
				  });

	              
	              //设置默认勾选商品
	              setTimeout(function() {_this.defaultselectgoods()},100);
	          }
	          if(this.isnewselect==true) this.isnewselect=false;
          }).catch((res) => {
              this.addListLoading=false;
              if(this.isnewselect==true) this.isnewselect=false;
          });
      },
    
      productPageSizeChange(val) {
          this.productquery.rollpage = val;
          this.getProductList();
      },
      productPageCurrentChange(val) {
          this.productquery.p = val;
          this.getProductList();
      },
      
      /** 光标监听在关键字搜索 **/
      setkeylisten() {
      	  document.getElementById('searchInput').focus();
      },
      
      //检测商品最近是否被盘点过
      checklog() {
      	  var resource = this.$resource(this.url);
      	  resource.save({act:'checkmakelog',token:this.$cookies.get('token')}).then((res) => {
		      if(res.data.Result>0){
			      if(res.data.Result=='70001') this.$router.push('/login')
			      this.$message.error(res.data.Message);
		      }else{
		          this.create.productlog = JSON.parse(Base64.decode(res.data.Data));
		          if(this.create.productlog.length > 0) {
					  this.covergoods='';
		              this.checkmakeDialog=true;
		          }else {
		          	  this.Savemakeinfos();
		          }
		      }
		  }).catch((res) => {
	      	  //this.$message.error(this.GLOBAL.errortext);
	      });    
      },
      
      //保存写入盘点信息
      Savemakeinfos() {
      	  this.checkmakeDialog=false;
      	  this.suresaveLoading=true;
          this.$confirm('温馨提示：确认盘点前请先确认盘点商品信息是否正确，您是否已确认盘点商品信息无误，继续?', '提示', { type: 'warning' }).then(() => {    	
		  	  // 向请求服务端删除
		      this.createsaveLoading=false;
			  var resource = this.$resource(this.url);			  
			  resource.save(this.create).then((res) => {
			      if(res.data.Result>0){
				  	  if(res.data.Result=='70001') this.$router.push('/login')
				      this.$message.error(res.data.Message);
				      //聚焦搜索关键字
			          this.setkeylisten();
			      }else{
			          this.$message.success('商品盘点成功！');
			          this.getlists();
			          //聚焦搜索关键字
			          this.setkeylisten();			              
			      }
			      this.createsaveLoading=false;
			      this.suresaveLoading=false;
			  }).catch((res) => {
			  	  this.createsaveLoading=false;
			  	  this.suresaveLoading=false;
		      });
	      }).catch(() => {
		  	  this.$message.info('已取消操作!');
		  	  this.suresaveLoading=false;
		  });
      },
      
      
      /** 设置默认选择的商品信息 **/
      defaultselectgoods() {
          var _this=this;
          var productids=[]; 
          var number=-1; 
      	  //获取已选中的商品id
      	  this.multipleSelection.forEach(function(e,index) {productids.push(e.id)});
      	  productids.forEach(function(e,i) {
      	  	  number=-1;
      	  	  _this.productlists.forEach(function(ee,ii) {if(e==ee.id) number=ii});
      	  	  if(number >= 0) _this.$refs.multipleTable.toggleRowSelection(_this.productlists[number]);    	
      	  });	    
      },
      
      
      /** 点击选择产品 **/
      handleSelectRow(row,event,column) {
      	  this.issingleclick=true; //开启单选模式
          
          this.nowtime ++;
    	  if(this.timeoutflag==false) return false;    	
    	  var _this=this;
    	  this.timeoutflag=false;
    	  setTimeout(function() {
    		  if(_this.nowtime==1) { //单击事件
    			  _this.selectrow(row,event);
    		  }else { //双击事件
    			  _this.selectdouble(row,event);
    		  }
    		  _this.nowtime=0;
    		  _this.timeoutflag=true;
    		  _this.issingleclick=false;
    	  },250);
      },
      
      //单击事件添加商品进入已选择商品列表
      selectrow(row,event) {
      	  var _this=this;
      	  var number=-1; //当前点击的商品位置信息
      	  
      	  //勾选/取消勾选选中的商品信息
      	  this.productlists.forEach(function(e,index) {if(e.id==row.id) _this.$refs.multipleTable.toggleRowSelection(_this.productlists[index])});
      	  //获取商品在已选中商品里的位置
      	  this.multipleSelection.forEach(function(e,index) {if(row.id==e.id) number=index});     	  
      	  number >= 0 ? this.multipleSelection.splice(number,1) : this.multipleSelection.push(row);
      },
      
      //双击事件直接将商品添加入购物车
      selectdouble(row,event) {
      	  this.multipleSelection=[];
      	  this.multipleSelection.push(row);
      	  this.addCart();
      },
      
      //勾选单个商品
      handleSelectsingle(event,row) {
      	  var _this=this;
      	  var number=-1; //当前点击的商品位置信息
      	  //获取商品在已选中商品里的位置
      	  this.multipleSelection.forEach(function(e,index) {if(row.id==e.id) number=index});     	  
      	  number >= 0 ? this.multipleSelection.splice(number,1) : this.multipleSelection.push(row);
      },
      
      //多选商品信息
      handleSelectall(val) {
      	  if(this.issingleclick==true) return false;      	  
      	  var _this=this;
      	  var data=this.productlists;
      	  var selectids=[];
      	  var row='';
      	  var rownumber=-1;
      	  data.forEach(function(e,index) {data[index].status=0});
      	  
      	  if(val.length > 0) {
      	  	  val.forEach(function(e,index) {
      	  	  	  row=e;
      	  	  	  rownumber=-1;
      	  	  	  data.forEach(function(ee,ii) {if(e.id==ee.id) rownumber=ii});
 				  if(rownumber >= 0) data[rownumber].status=1;     	  	  	  
      	  	  });
      	  }
      	  
      	  data.forEach(function(e,i) {
      	  	  rownumber=-1;
      	  	  _this.multipleSelection.forEach(function(ee,ii) {if(e.id==ee.id) rownumber=ii});
      	  	  if(e.status==0 && rownumber>=0) _this.multipleSelection.splice(rownumber,1);
      	  	  if(e.status==1 && rownumber<0) _this.multipleSelection.push(e);
      	  });
      },
      
      
      /** 添加商品进购物车 **/
      addCart() {
      	  this.addSave();
      	  var _this=this;                 
          //聚焦最后一个商品的实际库存
          setTimeout(function () {
          	  _this.lists[0].reainventory='';
              document.getElementById('realfirst').focus();
		  },500);
      },
      
      productPageSizeChange(val) {
          this.productquery.rollpage = val;
          this.getProductList();
      },
      productPageCurrentChange(val) {
          this.productquery.p = val;
          this.getProductList();
      },
      
      /** 商品添加进购物车 **/
      addSave(){          
          this.addProductLoading=true;
          var resource = this.$resource(this.url);
          resource.save({act:'addproduct',warehouseid:this.productquery.warehouse,product:this.multipleSelection,token:this.$cookies.get('token')}).then((res) => {
              if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	              this.addProductLoading=false;
              }else{
                  this.$message.success('添加盘点商品成功');
                  this.addDialog=false;
                  this.addProductLoading=false;
                  this.getlists(); 				
              }
          }).catch((res) => {
              //this.$message.error(this.GLOBAL.errortext);
              this.addDialog=false;
              this.addProductLoading=false;
          });
      },
      
      /** 上传文件 **/
      uploadinfos() {
      	  document.getElementById("fileupload").click();
      },
      
      
      /********** 上传文件（txt、excel格式） ***********/
      importfile(obj) {    
    	  let _this = this;
          let inputDOM = this.$refs.inputer;
          // 通过DOM取文件数据
          this.file = event.currentTarget.files[0];
        
          var filename=this.file.name;
          filename=filename.split('.');
          var type=filename[filename.length-1];
          
          this.uploadgoodsLoading=true;	
          type=='txt' ? this.importtxt() : this.importxls();                 
      },
      /******** 上传文件（txt、excel格式） ********/
      
      //导出未盘点商品信息
	  exportgoods() {
	  	  this.exportDialog=true;
	  	  this.exportlists=[];
	  	  this.exportquery.date='';
	      this.exportquery.warehouseid='';
	      this.exportquery.managerid='';
	      this.exportquery.brandid='';
	      this.exportquery.catid='';
	  },

	  //上传txt文件
      importtxt() {
      	  var file = document.getElementById("fileupload").files[0];
      	  var reader = new FileReader();
      	  var outdata=[];
      	  let _this=this;
      	  reader.readAsText(file, "gb2312");
      	  reader.onload = function (e) {
      	  	  //清空输入框的文件值，避免下次change事件失效
              document.getElementById('fileupload').value = null;
	          outdata = e.target.result.split("\n");          
	          var resource = _this.$resource(_this.url);
              resource.save({act:'inputinfos',infos:outdata,type:'txt',token:_this.$cookies.get('token')}).then((res) => {
                  if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')
                      _this.uploadgoodsLoading=false;
                      _this.$message({
				          dangerouslyUseHTMLString: true,
				    	  type:'error',
				    	  message:'<span style="line-height:20px">'+res.data.Message+'</span>',
			    	  });
                  }else{
                      var data=JSON.parse(Base64.decode(res.data.Data));
                      _this.productsmore=[];
                      _this.productnotice=[];
                      _this.productsmore=data.lists;
                      _this.productnotice=data.error;                      
                      _this.uploadgoodsLoading=false;
                      _this.$message.success('导入商品信息成功!');                      
                      if(data.error.length > 0) _this.addmorenoticeDialog=true;
                  }
              }).catch((res) => {
                  _this.uploadgoodsLoading=false;
                  _this.$message.error(this.GLOBAL.errortext);
              }); 
	          
      	  }
      	  
      },
      
      
      //上传xls文件
      importxls() {      
      	  let _this = this;
      	  this.file = event.currentTarget.files[0];
      	  var rABS = false; //是否将文件读取为二进制字符串
          var f = this.file;
          var outdata;
          var reader = new FileReader();
          FileReader.prototype.readAsBinaryString = function(f) {
        	  var binary = "";
              var rABS = false; //是否将文件读取为二进制字符串
              var pt = this;
              var wb; //读取完成的数据
              var reader = new FileReader();
              reader.onload = function(e) {
            	  var bytes = new Uint8Array(reader.result);
                  var length = bytes.byteLength;
                  for(var i = 0; i < length; i++) binary += String.fromCharCode(bytes[i]);
                  var XLSX = require('xlsx');
                  if(rABS) {
                	  wb = XLSX.read(btoa(fixdata(binary)), {type:'base64'});
                  }else {
                      wb = XLSX.read(binary, {type: 'binary'});
                  }
                  outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);//outdata就是你想要的东西
                  //清空输入框的文件值，避免下次change事件失效
                  document.getElementById('fileupload').value = null;
                
                  //提交数据到后台
                  _this.uploadgoodsLoading=true;
        		  var resource = _this.$resource(_this.url);
                  resource.save({act:'inputinfos',infos:outdata,type:'xls',token:_this.$cookies.get('token')}).then((res) => {
                      if(res.data.Result>0){
                    	  if(res.data.Result=='70001') this.$router.push('/login')
                    	  _this.uploadgoodsLoading=false;
                    	  _this.$message({
				    		  dangerouslyUseHTMLString: true,
				    		  type:'error',
				    		  message:'<span style="line-height:20px">'+res.data.Message+'</span>',
			    		  });
                      }else{
                    	  var data=JSON.parse(Base64.decode(res.data.Data));
	                      _this.productsmore=[];
	                      _this.productnotice=[];
	                      _this.productsmore=data.lists;
	                      _this.productnotice=data.error;                      
	                      _this.uploadgoodsLoading=false;
	                      _this.$message.success('导入商品信息成功!');                      
	                      if(data.error.length > 0) _this.addmorenoticeDialog=true;
                  	  }
                  }).catch((res) => {
                	  _this.uploadgoodsLoading=false;
                      _this.$message.error(this.GLOBAL.errortext);
                  });        
                           
              }
              reader.readAsArrayBuffer(f);
          }
               
          if(rABS) {
        	  reader.readAsArrayBuffer(f);
          } else {
              reader.readAsBinaryString(f);
          } 
      },
	  
	  //批量新增盘点商品信息
      addmoreSave() {
      	  this.addmoreloading=true;
	      var resource = this.$resource(this.url);
	      resource.save({act:'saveinfos',infos:this.productsmore,warehouseid:this.productquery.warehouse,token:this.$cookies.get('token')}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.addmoreloading=false;
	              this.$message.error(res.data.Message);
	          }else{
	              this.addmoreloading=false;
	              this.addmoreDialog=false;
	              this.getlists();
	              //聚焦搜索关键字
	              this.setkeylisten();
	              this.$message.success('批量导入盘点商品信息成功!');
	          }
	      }).catch((res) => {
	      	  this.addmoreloading=false;
	          //this.$message.error(this.GLOBAL.errortext);
	      });  	  
      },
      
      //获取未盘点商品信息
	  getUncounted() {
	  	  this.exportLoading=true;
	  	  var resource = this.$resource(this.GLOBAL.exportUrl+"StockInventory/index");
	      resource.save(this.exportquery).then((res) => {
	    	  if(res.data.Result>0){
		    	  if(res.data.Result=='70001') this.$router.push('/login')
		          this.$message.error(res.data.Message);
		          this.exportLoading=false;
	          }else{
		          this.exportlists=JSON.parse(Base64.decode(res.data.Data));
		          this.exportLoading=false;
	          }
	      }).catch((res) => {
	          this.exportLoading=false;
	      });
	  },
	  
	  //导出未盘点商品信息
	  exportdata() {
	  	  if(this.exportlists.length==0) {this.$message.error("没有未盘点商品需要导出");return false;}	  
	  	  require.ensure([], () => {
			var { export_json_to_excel } = require('../../vendor/Export2Excel');
			var tHeader = ['商品名称','品牌','编号','规格','条形码','系统数量','实际库存数量'];
			var filterVal = ['name','brandname','number','spec','basebarcode','basenum','realinventory'];
				
			var list = this.exportlists;
			var data = this.formatJson(filterVal, list);
			export_json_to_excel(tHeader, data, '未盘点商品信息');
			this.exportDialog=false;
		  })
	  },
	  
	  //导出表格数据
	  formatJson(filterVal, jsonData) {
　　   	  return jsonData.map(v => filterVal.map(j => v[j]));
　　  },

	 //全选叠加、覆盖、忽略
	 changecover() {
		 let _this=this; 
		 this.create.productlog.forEach(function(item,i) {
			 _this.create.productlog[i].type=_this.covergoods;
		 });
	 },
      
          
  },
  
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 3% 1%}
.notice {float:left;width:96%;padding:5% 2% 5% 2%;font-size:15px}
.stockallcover {float:right;margin-right:2%}
.stockallcover .el-radio.is-bordered,.singlecover .el-radio.is-bordered {background:rgb(220,223,230,0.3)}
.stockallcover .el-radio.is-bordered.is-checked,.singlecover .el-radio.is-bordered.is-checked {background:rgb(64,158,255);}
.stockallcover .stockallcover .el-radio.is-bordered {background:#409EFF}
.stockallcover .el-radio__input.is-checked+.el-radio__label,.singlecover .el-radio__input.is-checked+.el-radio__label {color:#fff}
.stockallcover .el-radio__input.is-checked .el-radio__inner,.singlecover .el-radio__input.is-checked .el-radio__inner {border-color:#E6A23C;background:#E6A23C}


.cz-sell-base-lists-infos-out {display:inline-block;width:100%;}
.cz-sell-base-lists-infos {float:left;display:flex;justify-content:left;align-items:center;font-size:0;width:25%;height:50px;overflow:hidden;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-title {float:left;text-align:right;font-size:13px;line-height:23px;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content {float:left;margin-left:10px;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-input__inner {text-align:left;width:220px;border-bottom:1px solid #dcdfe6;border-top:none;border-left:none;border-right:none;border-radius:0;height:40px;line-height:40px;font-size:13px;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-input__inner:hover {box-shadow:none;border-bottom:1px solid #dcdfe6;}
.cz-sell-base-lists-infos .el-input.is-active .el-input__inner, .cz-sell-base-lists-infos .el-input__inner:focus {border-color:#dcdfe6 !important;}
.cz-sell-base-lists-infos .cz-sell-base-lists-infos-content .el-checkbox__inner {margin-top:7px}

.cz-sell-base-lists-infos-goods {display:inline-block;width:100%;margin-top:20px;}
.cz-sell-base-lists-infos-goods .el-table {font-size:13px;}
.cz-sell-base-lists-infos-goods .el-table th.is-leaf {background:#E4E7ED;}
.cz-sell-base-lists-infos-goods .el-table td, .cz-sell-base-lists-infos-goods .el-table th.is-leaf {border-bottom:1px solid #E4E7ED;}
.cz-sell-base-lists-infos-goods .el-table .el-table_body tr,.cz-sell-base-lists-infos-goods .el-table .hover-row > td {background-color:#E4E7ED;}
.cz-sell-base-lists-infos-goods .el-table__fixed-footer-wrapper tbody td {background:#E4E7ED;border-bottom:1px solid #E4E7ED;}
.cz-sell-base-lists-infos-goods .el-input__inner {overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:center;border-bottom:none;border-top:none;border-left:none;border-right:none;border-radius:15px;height:32px;line-height:32px;font-size:13px;}
.cz-sell-base-lists-infos-goods .el-input__inner:hover {box-shadow:none;border:none;}
.cz-sell-base-lists-infos-goods .el-table__footer-wrapper tbody td, .cz-sell-base-lists-infos-goods .el-table__header-wrapper tbody td {background-color:#E4E7ED;}
.cz-sell-base-lists-infos-goods .el-table--enable-row-hover .el-table__body tr:hover>td {background-color:#E4E7ED;}
.cz-sell-order-stat {width:calc(100%);height:100px;position:relative;margin-top:10px;margin-bottom:20px;background:none;display:flex;justify-content:center;align-items:center;}
.cz-sell-order-stat-handles {padding:10px 20px;height:60px;border-left:1px solid #EBEEF5;width:30%;display:flex;justify-content:left;align-items:center;overflow:hidden;}
.cz-sell-order-stat-totals {padding:10px 20px;height:100px;width:calc(100% - 30% - 40px - 40px - 1px);display:flex;justify-content:left;align-items:center;overflow:hidden;}
.cz-sell-order-stat-totals-name {float:left;width:calc(25% - 30px) !important;padding:3px 30px 0 0 !important;font-size:13px;}
.cz-sell-order-stat-totals-name-title {float:left;width:80px;}
.cz-sell-order-stat-totals-name-content {float:left;width:calc(100% - 100px - 10px - 30px);padding:0 15px;color:red;font-weight:550;font-size:14px;}

.cz-sell-order-stat-totals-name .el-input {width:calc(100% - 80px - 5px);font-size:14px;}
.cz-sell-order-stat-totals-name .el-input__inner {color:red;font-weight:550;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:center;border-bottom:1px solid #c0c4cc !important;border-top:none;border-left:none;border-right:none;border-radius:0;height:32px;line-height:32px;font-size:13px;background:none;text-align:left;}
.cz-sell-order-stat-totals-name .el-input__inner:hover {box-shadow:none;border:none;border-bottom:1px solid #c0c4cc !important;background:none;}
.cz-sell-order-stat-totals-name .el-input.is-active .el-input__inner, .cz-sell-order-stat-totals-name .el-input__inner:focus {border-color:#c0c4cc !important;background:none;}
</style>


// WEBPACK FOOTER //
// src/components/home/Makeinventoryadd.vue